<template>
  <FormContainer @submitForm="signup">
    <Alert v-if="alert.status" class="mt-2" :status="alert.status">
      {{ alert.message }}
    </Alert>

    <div class="container-fluid" v-if="alert.status !== 'success'">
      <div class="row">
        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Nome"
          v-model="userCopy.name"
          :errorMsg="errorHash.name"
          @input="removeError('name')"
        />
        <FormInputTextWidget
          class="col-12 col-md-6"
          label="Cognome"
          v-model="userCopy.surname"
          :errorMsg="errorHash.surname"
          @input="removeError('surname')"
        />
      </div>

      <div class="row mt-2">
        <FormInputTextWidget
          class="col-12"
          label="Email"
          disabled
          :value="userCopy.email"
          type="email"
        />
      </div>

      <div class="row mt-2">
        <FormInputIntegerWidget
          class="col-lg-4 col-sm-6"
          label="Aziende creabili"
          v-model.number="companiesAdd"
          min="0"
          :disabled="finiteCompanies"
          :errorMsg="errorHash['companiesAdd']"
          @input="removeError('companiesAdd')"
        />
        <div class="col-lg-8 col-sm-6 d-flex align-items-center">
            <BFormCheckbox
              v-model="finiteCompanies"
              name="finiteCompanies"
              switch
              @input="companiesAmount()"
            >
            Aziende creabili illimitate
            </BFormCheckbox>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex align-items-center">
            <BFormCheckbox
              v-model="userCopy.canInviteUsers"
              name="canInviteUsers"
              switch
            >
            Può invitare utenti
            </BFormCheckbox>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 d-flex align-items-center">
            <BFormCheckbox
              v-model="userCopy.canEditModules"
              name="canEditModules"
              switch
            >
            Può gestire i moduli
            </BFormCheckbox>
        </div>
      </div>
    </div>
    <div class="pt-5 text-right">
      <button class="btn btn-primary" type="submit" v-if="!alert.status">
          Aggiorna
      </button>
      <button class="btn btn-primary" type="button" v-else @click="$emit('closeModal', true)">
          Chiudi
      </button>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'consultant-edit',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputIntegerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputIntegerWidget'),
    BFormCheckbox,
    Alert: () => import('@/libs/Feedback/components/Alert'),
  },
  props: {
    user: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        surname: null,
        email: null,
        maxCompaniesAllowed: null,
      }),
    },
  },
  data () {
    return {
      alert: {
        status: null,
        message: null,
      },
      showLogin: false,
      fixedMaxFiles: 1,
      privacy: false,
      confirmPassword: null,
      userCopy: { ...this.user },
      companiesAdd: this.user.maxCompaniesAllowed,
      finiteCompanies: !this.user.maxCompaniesAllowed,
    };
  },
  methods: {
    signup () {
      if (!this.isValid()) {
        return;
      }

      if (this.finiteCompanies) {
        this.userCopy.maxCompaniesAllowed = null;
      } else {
        this.userCopy.maxCompaniesAllowed = this.companiesAdd;
      }

      const successHandler = res => {
        this.alert.status = 'success';
        this.alert.message = 'Dati del profilo aggiornati con successo';
        this.$oauth2.getMe(true);
        this.$emit('update', res);
      };

      this.$api.updateProfile({ ...this.userCopy })
        .then(successHandler)
        .catch(err => {
          this.$emit('error', err);

          if (err.response.status === 406 && err.response.data.type === 'address') {
            this.addressSuggestions = err.response.data.address_suggest;
            this.addError('Errore', 'address');
          }
          if (err.response.data.msg) {
            this.alert.status = 'danger';
            this.alert.message = err.response.data.msg;
          }
        })
      ;
    },
    companiesAmount () {
      if (this.finiteCompanies) {
        this.companiesAdd = null;
      } else {
        this.companiesAdd = this.userCopy.maxCompaniesAllowed;
      }
    },
    isValid () {
      this.clearErrors();

      // name
      if (!this.userCopy.name) {
        this.addError('Inserisci il nome', 'name');
      }
      // surname
      if (!this.userCopy.surname) {
        this.addError('Inserisci il cognome', 'surname');
      }

      return !this.hasErrors;
    },
    resetFeedBack () {
      this.alert.status = null;
      this.alert.message = null;
    },
  },
  mounted () {},
};

</script>

<style lang="scss"></style>
